import React from "react";
import { Card, CardMedia, Box, Typography } from "@mui/material";
import classes from "./JobOfferEntry.module.css";
import LocationOnIcon from "@mui/icons-material/LocationOn";
import DateRangeIcon from "@mui/icons-material/DateRange";
import { useNavigate } from "react-router";
import { Timestamp } from "@firebase/firestore";

function JobOfferEntry(props) {
  const navigate = useNavigate();
  const { photo, name, location, time, reward, id } = props;
  const dateObj = new Timestamp(time.seconds, time.nanoseconds).toDate();
  return (
    <Card
      className={classes.card}
      onClick={() => {
        navigate(`/ponukaprace/${id}`);
      }}
    >
      <Box className={classes.textPart}>
        <Typography component="div" variant="h3">
          {name}
        </Typography>
        <Typography
          variant="h4"
          component="div"
          sx={{ fontWeight: 400, display: "flex", alignItems: "center" }}
        >
          <LocationOnIcon
            sx={{
              height: 40,
              width: 40,
              paddingRight: 1,
            }}
          />
          {location}
        </Typography>
        <Typography
          variant="h4"
          component="div"
          sx={{ fontWeight: 400, display: "flex", alignItems: "center" }}
        >
          <DateRangeIcon
            sx={{
              height: 40,
              width: 40,
              paddingRight: 1,
            }}
          />
          {`${dateObj.toLocaleDateString().replace(/[ ]/g, "")}`}
        </Typography>
      </Box>

      <CardMedia
        className={classes.photoPart}
        component="img"
        image={photo}
        alt="logo thumbnail"
        sx={{
          width: 300,
          objectFit: "contain",
        }}
      />
    </Card>
  );
}

export default JobOfferEntry;
